.today {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

@media (min-width: 720px) {
  .today {
    gap: 28px;
  }
}

.summary {
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

/* The inset line between the week and the appointment: the same padding on
 * both sides as the content above and below it. */
.rule {
  margin: 0 20px;
  border-top: 1.5px solid var(--ink);
}

/* One column on a phone; on a desktop today's record beside the wider
 * questionnaires card. */
.columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

@media (min-width: 720px) {
  .columns {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr);
  }
}
